import { compose } from 'recompose';

import withAcls from '~/common/hoc/withAcls';

const enhancer = compose(withAcls);

export default enhancer;
